import React from 'react';
import { translate } from '../../utils/util';

const ListUI = (props) => {
    return (
        <div className="row" style={{ marginBottom: '0px' }}>
            <ul className={`${props.data.length > 0 ? 'collection ' : ''} : col s12`} style={{ padding: '0', marginTop: '0' }}>
                {
                    props.data.map((item, index) => (
                        <li
                            key={`oi-${index}`}
                            style={{ backgroundColor: 'white', boxShadow: '0 1px 5px 0 rgba(0,0,0,0.2)', padding: '4px' }}
                        >
                            {
                                item
                            }
                        </li>
                    ))
                }
                {
                    props.data.length === 0 && (
                        <div className="container-fluid h-65" style={{ textAlign: 'center' }}>
                            {translate('general:no-registry')}
                        </div>)
                }
            </ul>
        </div>
    );
};

export default ListUI;
